import React from 'react';
import {View} from 'react-native';
import {constant} from 'lodash/fp';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';
interface LoadingProps {
  renderTitle: () => string;
}

export const Loading: React.FC<LoadingProps> = ({
  renderTitle = constant(''),
}) => {
  const {tt} = useTranslation('reportCardContent.promotion');
  return (
    <View style={styles.base}>
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {renderTitle()}
        </Text>
      </Gutter>
      <View style={styles.listItemContainer}>
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            label={<Text>{tt('label.newHAR', 'New HRA')}</Text>}
            suffix={<LoadingBox style={styles.loadingBoxRankDescription} />}
          />
          <ListItem
            style={{base: styles.listItem}}
            label={<Text>{tt('label.previousHAR', 'Previous HRA')}</Text>}
            suffix={
              <LoadingBox style={styles.loadingBoxPreviousRankDescription} />
            }
          />
          <ListItem
            style={{base: styles.listItem}}
            label={<Text>{tt('label.rankUpFor', 'Rank Up For')}</Text>}
            suffix={<LoadingBox style={styles.loadingBoxPromotedOnDate} />}
          />
        </Gutter>
      </View>
    </View>
  );
};
